import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BackgroundImg from '../../assets/Background/agent_portal_hero_bg.png';
import LandingNavbar from './sections/Header/LandingNavbar';
import HeroSection from './sections/HeroSection/HeroSection';
import WhyTrripSection from './sections/WhyTrrip/WhyTrripSection';
import SmartVouchersSection from './sections/SmartVouchers/SmartVouchersSection';
import ModernTravelSection from './sections/ModernTravel/ModernTravelSection';
import LiveTrackingSection from './sections/LiveTracking/LiveTrackingSection';
import StartUsingSection from './sections/StartUsing/StartUsingSection';
import FaqSection from './sections/Faq/FaqSection';
import FooterSection from './sections/Footer/FooterSection';

const LandingPage = ({ defaultTab = 'login' }) => {
  const navigate = useNavigate();

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    const token = localStorage.getItem('token_agents');
    const agentId = localStorage.getItem('agent_id');

    if (token && agentId) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen w-full font-sans selection:bg-[#4ed0d0]/30 relative overflow-x-hidden bg-[#f8fafc]">
      {/* Global Landing Styles */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');
        body { font-family: 'Manrope', sans-serif; background-color: #f8fafc; }
        .bg-main { background-image: url('${BackgroundImg}'); background-size: cover; background-position: center; background-repeat: no-repeat; }
      `}</style>

      {/* Header / Navbar */}
      <LandingNavbar />

      {/* Hero Section (Left Hero Content + Right Auth Card) */}
      <HeroSection defaultTab={defaultTab} />

      {/* Extended Landing Content Sections */}
      <div id="about-section" className="relative z-10 -mt-8 pt-16 bg-[#f8fafc] scroll-mt-20">
        <WhyTrripSection />
        <div id="features" className="scroll-mt-20">
          <SmartVouchersSection />
        </div>
        <div id="how-it-works" className="scroll-mt-20">
          <ModernTravelSection />
        </div>
        <div>
          <LiveTrackingSection />
        </div>
        <div id="get-started" className="scroll-mt-20">
          <StartUsingSection />
        </div>
        <div id="faqs" className="scroll-mt-20">
          <FaqSection />
        </div>
        <FooterSection />
      </div>
    </div>
  );
};

export default LandingPage;
